import type { CalculatorArticleContent } from "../calculator-article";

export const ipfGlGuide: CalculatorArticleContent = {
  id: "ipf-gl",
  eyebrow: "Powerlifting puanlama rehberi",
  updatedAt: "29 Eylül 2026",
  articleTitle: "IPF GL puanını doğru hesaplamak ve yorumlamak",
  intro:
    "IPF GL, farklı vücut ağırlıklarındaki powerlifting sporcularının üç kaldırış totalini ortak bir puan ölçeğine dönüştürür. Puan; vücut ağırlığı, cinsiyet, ekipman kategorisi ve yarışma totalinden hesaplanır. Mutlak gücü silmez, karşılaştırmayı daha anlamlı hâle getirmeye çalışır.",
  sections: [
    {
      id: "ipf-gl-nedir",
      title: "IPF GL nedir ve neden kullanılır?",
      paragraphs: [
        "Powerlifting'de daha ağır sporcular genellikle daha yüksek mutlak total yapabilir; buna karşılık vücut ağırlığı iki katına çıktığında kaldırılan yük aynı oranda artmaz. IPF GL formülü bu doğrusal olmayan ilişkiyi katsayılarla modelleyerek farklı sıkletlerdeki performansları karşılaştırır.",
        "International Powerlifting Federation, Wilks yerine kendi puanlama yaklaşımını geliştirdi ve 2020'de IPF GL katsayılarını yayımladı. Formül Classic ve Equipped kategorileri için, kadın ve erkek sporculara ayrı katsayı setleri kullanır. Bu nedenle doğru kategori seçimi sonucun temel parçasıdır.",
        "IPF GL bir yarışma derecesi, teknik puanı veya sağlık ölçümü değildir. Aynı koşullardaki totalin vücut ağırlığına göre ölçeklenmiş ifadesidir. Resmî sıralama için ilgili yarışmanın kategori ve sonuç kuralları ayrıca geçerlidir.",
      ],
      sourceIds: ["1", "2"],
    },
    {
      id: "dogru-girdiler",
      title: "Hesaplayıcıya hangi değerler girilmeli?",
      paragraphs: [
        "Vücut ağırlığını tartıdaki kilogram değeri olarak, powerlifting totalini ise geçerli en iyi squat, bench press ve deadlift sonuçlarının toplamı olarak gir. Yarışma puanı hesaplıyorsan yalnız hakemler tarafından geçerli sayılan kaldırışları kullan.",
        "Antrenmandaki teorik maksimumları toplayıp puan hesaplayabilirsin; fakat bunu yarışma sonucu olarak adlandırmamalısın. Antrenman standardı, ekipman, yorgunluk ve hakem komutları farklıdır. Kendi gelişimini izlerken her ölçümde aynı standardı korumak daha değerlidir.",
        "Classic kategorisinde destekleyici ekipman kullanımı sınırlıdır; Equipped kategorisinde squat suit ve bench shirt gibi ekipmanlar performans dağılımını değiştirir. Formüldeki kategori seçimi yalnız görünüm tercihi değil, farklı katsayı setidir.",
      ],
      table: {
        caption: "IPF GL hesabında giriş kontrolü",
        headers: ["Girdi", "Doğru kullanım", "Kaçınılacak hata"],
        rows: [
          [
            "Vücut ağırlığı",
            "Aynı performans günündeki kg değeri",
            "Başka dönemdeki en düşük kiloyu kullanmak",
          ],
          [
            "Total",
            "Squat + Bench Press + Deadlift",
            "Tek kaldırışı total alanına yazmak",
          ],
          [
            "Kategori",
            "Gerçek Classic veya Equipped kategori",
            "Daha yüksek puan verdiği için kategori değiştirmek",
          ],
          [
            "Cinsiyet katsayısı",
            "Formüldeki ilgili katsayı seti",
            "Farklı setleri aynı ölçek sanmak",
          ],
        ],
      },
      sourceIds: ["1", "3"],
    },
    {
      id: "formul",
      title: "IPF GL formülü nasıl çalışır?",
      paragraphs: [
        "Basitleştirilmiş biçimiyle puan, totalin vücut ağırlığına bağlı bir katsayıyla çarpılmasıdır. Katsayı doğrusal değildir; resmî tabloda A, B ve C parametreleri kategoriye göre değişir. Hesaplayıcı seçtiğin kategori için resmî katsayıları kullanır.",
        "Puanın artması iki yoldan olabilir: aynı vücut ağırlığında totalini artırmak veya totalini büyük ölçüde korurken daha düşük vücut ağırlığında yarışmak. İkinci yolun her sporcu için doğru strateji olduğu sonucu çıkmaz. Hızlı kilo kaybı performansı, toparlanmayı ve sağlığı olumsuz etkileyebilir.",
        "Ondalık farkları gereğinden fazla yorumlama. Tartı hassasiyeti ve totaldeki küçük değişiklikler puanı etkiler; ancak yarışma sonucunu yalnız birkaç ondalık üzerinden değerlendirmek yerine geçerli kaldırışlar, deneme seçimi ve uzun dönem gelişimi birlikte düşün.",
      ],
      sourceIds: ["1"],
    },
    {
      id: "yorumlama",
      title: "IPF GL puanı nasıl yorumlanmalı?",
      paragraphs: [
        "Puan en çok aynı kural seti ve ekipman kategorisindeki performansları karşılaştırırken anlamlıdır. Farklı yaş grupları, federasyonlar, hareket standartları veya test ortamları aynı sayı olsa bile eşdeğer değildir. Karşılaştırmanın bağlamını belirtmek gerekir.",
        "Kendi gelişimini izlerken vücut ağırlığı ve total değişimini ayrı ayrı kaydet. Örneğin puanın sabit kalırken totalin yükseliyorsa vücut ağırlığın da artmış olabilir. Puanın yükselirken totalin düşüyorsa kilo değişimi katsayıyı etkilemiş olabilir. Tek sayı yerine iki girdiyi birlikte görmek daha iyi karar sağlar.",
        "Takım veya yarışma seçimi gibi resmî süreçlerde organizasyonun o yıl kullandığı kural kitabını kontrol et. IPF teknik kuralları ve katsayıları zaman içinde güncellenebilir; üçüncü taraf hesaplayıcıyı nihai resmî kayıt yerine kullanma.",
      ],
      sourceIds: ["2", "3"],
    },
    {
      id: "ipf-gl-wilks",
      title: "IPF GL ve Wilks arasındaki fark",
      paragraphs: [
        "Wilks ve IPF GL aynı probleme farklı katsayılarla yaklaşır. Aynı sporcu, aynı vücut ağırlığı ve aynı totalle iki farklı puan alır. Sayıların büyüklüğünü doğrudan karşılaştırmak doğru değildir; bir IPF GL puanının Wilks karşılığını yalnız rakama bakarak söyleyemezsin.",
        "Güncel IPF bağlamında IPF GL kullanılır. Eski yarışma sonuçları, kulüp standartları veya tarihsel kayıtlar Wilks gösterebilir. Hangi sistemi kullandığını raporda açıkça yazmak, puanın yanlış ölçekle yorumlanmasını önler.",
        "İki formül de sporcu kalitesinin tamamını ölçmez. Deneme yönetimi, sakatlık durumu, teknik güvenilirlik ve yarışma sıklığı puanda görünmez. Formül performans verisini özetler; koçluk değerlendirmesinin yerini almaz.",
      ],
      sourceIds: ["2", "4"],
    },
    {
      id: "yaygin-hatalar",
      title: "Sık yapılan hesaplama hataları",
      paragraphs: [
        "Puan formülü otomatik olsa da yanlış girdi, anlamlı görünen fakat geçersiz sonuç üretir. Kaldırışların aynı yarışmaya ait olduğundan emin ol ve hesaplamadan önce şu kontrolleri yap.",
      ],
      bullets: [
        "Squat, bench press ve deadlift totalini değil tek bir kaldırışı girmek.",
        "Pound değerini kilogram alanına dönüştürmeden yazmak.",
        "Classic sporcu için Equipped katsayısı seçmek.",
        "Farklı tarihteki en iyi üç kaldırışı birleştirip yarışma totali gibi sunmak.",
        "Antrenman E1RM totalini hakem onaylı yarışma sonucu sanmak.",
        "Wilks ve IPF GL puanlarını aynı ölçeğin devamı gibi kıyaslamak.",
        "Puan yükseltmek için performans ve sağlık bağlamından bağımsız kilo düşürmek.",
      ],
    },
    {
      id: "uygulama-ornegi",
      title: "Uygulama örneği: puanı bileşenleriyle analiz etmek",
      paragraphs: [
        "Bir Classic sporcunun 82,5 kg vücut ağırlığında 220 kg squat, 145 kg bench press ve 250 kg deadlift yaptığını düşün. Powerlifting totali 615 kg'dır. Hesaplayıcı erkek Classic katsayısını 82,5 kg için uygular ve IPF GL puanını üretir. Burada giriş alanına 615 yazılır; üç kaldırış ayrı ayrı formüle girmez.",
        "Sonraki yarışmada sporcu 80,5 kg tartılıp 610 kg total yaparsa puanı, total beş kilogram düşmesine rağmen artabilir. Bu sonuç otomatik olarak daha iyi yarışma yaptığı anlamına gelmez. Kilo kesiminin performans ve toparlanma maliyeti, başarısız denemeler ve kişisel hedef ayrıca değerlendirilmelidir.",
        "Başka bir sporcu aynı 615 kg totalle Equipped kategorisinde yarışıyorsa Classic katsayısıyla karşılaştırılamaz. Doğru ekipman kategorisini seçmek gerekir. Benzer şekilde kadın ve erkek katsayıları birbirinin alternatifi değil, formülün farklı veri setleridir.",
        "Koçluk değerlendirmesinde puanı raporlarken vücut ağırlığı, squat, bench press, deadlift, total, kategori ve tarih birlikte tutulmalıdır. Puan yükseldiğinde bunun hangi kaldırıştan veya kilo değişiminden geldiği ancak bu ham verilerle anlaşılır. Amaç yalnız puan kovalamak değil, total gelişimini sürdürülebilir biçimde yönetmektir.",
      ],
      sourceIds: ["1", "3"],
    },
    {
      id: "yarismaya-uyarlama",
      title: "IPF GL'yi yarışma ve program kararlarına uyarlamak",
      paragraphs: [
        "IPF GL puanı hazırlık dönemindeki her kararı tek başına belirlememelidir. Yarışma seçerken puan hedefi kullanabilirsin; fakat antrenman programı kaldırış bazındaki ihtiyaca göre kurulmalıdır. Aynı puana sahip iki sporcudan biri bench press, diğeri deadlift nedeniyle sınırlanıyor olabilir. Total aynı özeti verirken çözüm farklıdır.",
        "Deneme seçiminde açılış, ikinci ve üçüncü haklar arasındaki risk yönetimi puanı doğrudan etkiler. Antrenmanda yüksek E1RM görmek, yarışmada aynı yükün geçerli olacağını garanti etmez. Komut, derinlik, duraklama ve platform stresi hesaba katılmalıdır. Güvenli açılış total oluşturur; agresif fakat gerçekçi üçüncü hak hedef puana yaklaşmayı sağlar.",
        "Sıklet kararı verirken farklı vücut ağırlıklarında olası total senaryolarını hesaplamak yararlı olabilir. Ancak yalnız katsayı avantajına bakmak yetersizdir. Kilo kesiminin squat stabilitesi, bench press kaldıraçları, toparlanma ve sakatlık riski üzerindeki etkisi sporcudan sporcuya değişir. Daha hafif tartılmak, kaybedilen total katsayı kazancından büyükse puanı düşürür.",
      ],
      subsections: [
        {
          title: "Takım puanı ve bireysel puan",
          paragraphs: [
            "Bazı organizasyonlar takım sıralaması, seçme standardı veya en iyi sporcu ödülü için puan formülü kullanabilir. Kuralın hangi kategori ve sonuçları kabul ettiğini organizasyon belgesinden kontrol et. Genel hesaplayıcı, yarışmaya özgü takım puanı veya eleme prosedürünü otomatik olarak açıklamaz.",
            "Bireysel gelişimde ise aynı sporcunun zaman içindeki IPF GL eğilimi yararlı olabilir. Her yarışmada formül sürümü, ekipman kategorisi ve ham kaldırış sonuçlarını sakla. Böylece kural değişikliğini performans gelişimi sanmazsın.",
          ],
        },
        {
          title: "Yaş ve özel kategoriler",
          paragraphs: [
            "Temel IPF GL hesabı yaş bilgisi istemez. Sub-Junior, Junior, Open ve Masters sıralamalarındaki yaş ayrımı yarışma kategorisinden gelir. Yaşa özgü başka katsayı veya puan kullanılıyorsa ilgili organizasyonun kuralı ayrıca uygulanmalıdır.",
          ],
        },
      ],
      sourceIds: ["2", "3"],
    },
  ],
  faqs: [
    {
      question: "IPF GL ile Wilks aynı mı?",
      answer:
        "Hayır. Katsayıları ve sonuç ölçekleri farklıdır. Aynı total iki sistemde farklı puan üretir.",
    },
    {
      question: "IPF GL hesabında total ne demektir?",
      answer:
        "Yarışmadaki en iyi geçerli squat, bench press ve deadlift kaldırışlarının kilogram cinsinden toplamıdır.",
    },
    {
      question: "Antrenman totalimi girebilir miyim?",
      answer:
        "Kişisel takip için girebilirsin; fakat E1RM veya salon kaldırışlarından oluşan sonuç resmî yarışma puanı değildir.",
    },
    {
      question: "Classic ve Equipped neden farklı?",
      answer:
        "Destekleyici ekipman performans dağılımını değiştirdiği için resmî formülde ayrı katsayı setleri kullanılır.",
    },
    {
      question: "Tek kaldırış için IPF GL hesaplanır mı?",
      answer:
        "Bu araç üç kaldırış powerlifting totaline göre tasarlanmıştır. Bench-only gibi ayrı formatların resmî değerlendirmesi organizasyon kurallarına bağlıdır.",
    },
    {
      question: "Yüksek IPF GL puanı doğrudan sıralama mıdır?",
      answer:
        "Hayır. Puan karşılaştırma aracıdır; resmî sıralama yarışma, kategori ve ilgili federasyon kurallarına göre belirlenir.",
    },
    {
      question: "Vücut ağırlığım düşünce puanım her zaman artar mı?",
      answer:
        "Hayır. Kilo kaybı totalini azaltırsa puan artmayabilir. Performans, toparlanma ve sağlık birlikte değerlendirilmelidir.",
    },
    {
      question: "Hesaplayıcı resmî sonuç yerine geçer mi?",
      answer:
        "Hayır. Resmî sonuç için yarışma kayıtlarını ve geçerli kural kitabını esas al.",
    },
    {
      question: "IPF GL puanını artırmak için sıklet değiştirmeli miyim?",
      answer:
        "Yalnız katsayıya bakarak sıklet değiştirme. Daha düşük vücut ağırlığının total, toparlanma ve sağlık üzerindeki etkisini deneme senaryolarıyla değerlendir. Kilo düşerken kaybedilen total, katsayı avantajından büyük olabilir.",
    },
    {
      question: "Başarısız kaldırış total hesabına girer mi?",
      answer:
        "Hayır. Yarışma totalinde her disiplindeki en iyi geçerli kaldırış kullanılır. Kırmızı ışık alan veya tamamlanmayan deneme, antrenmanda kaldırılmış olsa bile resmî totale eklenmez.",
    },
    {
      question: "Aynı puana sahip iki sporcu eşit performans mı göstermiştir?",
      answer:
        "Formül açısından göreli performansları yakındır; fakat kaldırış dağılımı, teknik, yaş kategorisi ve yarışma koşulları farklı olabilir. Birkaç ondalık farkı mutlak sporcu kalitesi sıralaması gibi yorumlama.",
    },
    {
      question: "IPF GL sonucu neden başka siteden farklı çıkabilir?",
      answer:
        "Yanlış kategori, cinsiyet, birim veya katsayı sürümü fark yaratabilir. Her iki araçta aynı kilogram değerlerini ve Classic/Equipped seçimini kullandığını kontrol et; resmî IPF katsayılarını referans al.",
    },
    {
      question: "Yaş IPF GL formülünü değiştirir mi?",
      answer:
        "Temel formül yaş istemez. Junior, Open veya Masters sınıfları yarışma kategorisidir. Bir organizasyon yaş katsayısı uyguluyorsa bu, temel IPF GL hesabına ek ve organizasyona özgü kuraldır.",
    },
    {
      question: "Tartı kilosu mu, normal günlük kilom mu kullanılmalı?",
      answer:
        "Yarışma puanı için resmî tartıda kaydedilen vücut ağırlığını kullan. Günlük antrenman karşılaştırmasında ise performansla aynı gün ve benzer koşulda ölçülen ağırlığı seç; farklı dönemdeki en düşük kiloyu kullanmak puanı yapay olarak yükseltir.",
    },
  ],
  sources: [
    {
      id: "1",
      label: "International Powerlifting Federation — resmî IPF GL katsayıları",
      href: "https://www.powerlifting.sport/fileadmin/ipf/data/ipf-formula/IPF_GL_Coefficients-2020.pdf",
    },
    {
      id: "2",
      label: "International Powerlifting Federation — IPF Formula açıklaması",
      href: "https://www.powerlifting.sport/rules/codes/info/ipf-formula",
    },
    {
      id: "3",
      label: "IPF Technical Rules Book 2026",
      href: "https://www.powerlifting.sport/fileadmin/ipf/data/rules/technical-rules/english/IPF_Technical_Rules_Book_2026_1_January_2026.pdf",
    },
    {
      id: "4",
      label: "IPF — Wilks formülünden IPF formülüne geçiş duyurusu",
      href: "https://www.powerlifting.sport/about-ipf/news/news-detail/ipf-formula",
    },
  ],
  related: [
    {
      href: "/essay/1rm-calculator",
      label: "1RM değerini hesapla",
      description: "Çalışma setinden tahmini maksimumunu bul.",
    },
    {
      href: "/essay/wilks-calculator",
      label: "Wilks skorunu hesapla",
      description: "Aynı totali tarihsel Wilks katsayısıyla karşılaştır.",
    },
  ],
  primaryCta: {
    href: "/program",
    label: "Powerlifting programlarını incele",
    description:
      "Squat, bench press ve deadlift totalini planlı bir programla geliştir.",
  },
};
